export default __webpack_public_path__ + "static/media/Draig-Bold.8e76faf6.otf";